<template>
  <li class="search__categories-item">
    <a
    class="search__categories-anchor"
    :href="url"
    v-html="highlightedName"
    :data-index="index"
    :data-search-suggest-category="name"
    ></a>
  </li>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    highlightedName: {
      type: String,
      required: true
    },
    index: Number
  }
}
</script>
